import { TimelineMax, Expo, Power3 } from 'gsap/all';

export default function figure(el) {
  const img = el.querySelector('img');

  const tl = new TimelineMax({
    paused: true,
  });

  tl
    .addLabel('start')
    .to(el, 1.2, {
      x: 0,
      rotationX: 0,
      autoAlpha: 1,
      y: 0,
      ease: Expo.easeOut,
    }, 'start')
    .to(img, 1.2, {
      scale: 1,
      y: 0,
      ease: Power3.easeOut,
    }, 'start');

  return tl;
}
